import { useAuth } from '../AuthContext/AuthContext'
import { useNavigate } from 'react-router-dom'
import '../AuthButton/authButton.css'

function AuthButton() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  if (user) {
    return (
      <button className="auth-btn" onClick={logout}>
        Выйти
      </button>
    )
  } else {
    return (
      <button className="auth-btn" onClick={() => navigate('/auth')}>
        Войти
      </button>
    )
  }
}

export default AuthButton
